import React from 'react';
import { LayoutList, Grid2X2, AlignJustify } from 'lucide-react';

const MODES = [
  { key:'list',    Icon: LayoutList,    title:'List view' },
  { key:'grid',    Icon: Grid2X2,       title:'Grid view' },
  { key:'compact', Icon: AlignJustify,  title:'Compact view' },
];

export function useViewMode(storageKey, def='list') {
  const [mode, setMode] = React.useState(
    () => localStorage.getItem(storageKey) || def
  );
  const change = (m) => { setMode(m); localStorage.setItem(storageKey, m); };
  return [mode, change];
}

export default function ViewModeSwitcher({ mode, onChange, modes = ['list','grid','compact'] }) {
  const shown = MODES.filter(m => modes.includes(m.key));
  return (
    <div style={{ display:'flex', border:'1px solid var(--color-border)', borderRadius:8, overflow:'hidden', flexShrink:0 }}>
      {shown.map(({ key, Icon, title }) => (
        <button key={key} type="button" title={title}
          onClick={() => onChange(key)}
          className={`btn btn-sm ${mode===key ? 'btn-primary' : 'btn-ghost'}`}
          style={{ borderRadius:0, padding:'6px 10px', border:'none', display:'flex', alignItems:'center' }}>
          <Icon size={15} />
        </button>
      ))}
    </div>
  );
}
